var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFloorplan = function SvgFloorplan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25292D",
    d: "M3 10.18a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h10.225a.5.5 0 0 1 .5.5v8.807a.5.5 0 0 1-.5.5H8.387a.5.5 0 0 1-.5-.5V10.18H3zm9.725-5.68H3.5v4.68h4.887a.5.5 0 0 1 .5.5v2.627h3.838V4.5z"
  })));
};
export default SvgFloorplan;